// Keep CSS imports static at the top so styles don't flash layout shifted shifts
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'simplelightbox/dist/simple-lightbox.css';
import '../css/shared/blocks/gallery.css';

const galleries = document.querySelectorAll('.gallery');

// Only load modules if galleries exist on the current page
if (galleries.length > 0) {
    initGalleries();
}

async function initGalleries() {
    try {
        // 1. Dynamically import all packages concurrently
        const [
            { default: Swiper },
            { Navigation, Pagination, Thumbs },
            { default: SimpleLightbox }
        ] = await Promise.all([
            import('swiper'),
            import('swiper/modules'),
            import('simplelightbox')
        ]);

        // 2. Initialize elements now that dependencies have loaded
        galleries.forEach((element) => {
            const swiperElement = element.querySelector(".gallery-swiper");
            const thumbSwiperElement = element.querySelector(".gallery-thumbs");
            const thumbs = parseInt(element.dataset.thumbs) || 4;
            const swiperid = swiperElement.id;

            const thumbSwiper = new Swiper(thumbSwiperElement, {
                modules: [Thumbs],
                spaceBetween: 10,
                slidesPerView: thumbs,
                freeMode: true,
                watchSlidesProgress: true,
            });

            new Swiper(swiperElement, {
                modules: [Navigation, Thumbs, Pagination],
                slidesPerView: 1,
                loop: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                thumbs: {
                    swiper: thumbSwiper,
                },
                pagination: {
                    el: ".swiper-pagination",
                    dynamicBullets: true,
                    clickable: true
                },
            });

            new SimpleLightbox('#' + swiperid + ' a.swiper-slide', { /* options */ });
        });
    } catch (error) {
        console.error("Failed to load gallery dependencies dynamically:", error);
    }
}
